(function () {

  function initSection(section) {
    var sectionId = section.dataset.sbsId;
    if (!sectionId) return;

    // ── Carousel per panel ──────────────────────────────────────────
    function initCarousel(panel) {
      var wrap  = panel.querySelector('.sbs-carousel-wrap');
      var track = panel.querySelector('.sbs-track');
      if (!wrap || !track) return;

      var idx = 0;

      function cardWidth() {
        var c = track.querySelector('.sbs-card');
        return c ? c.offsetWidth + 20 : 0;
      }

      function visibleCount() {
        var w = wrap.offsetWidth;
        if (w < 600) return 1.2;
        if (w < 992) return 2;
        return 4;
      }

      function maxIdx() {
        var cards = track.querySelectorAll('.sbs-card');
        return Math.max(0, cards.length - Math.floor(visibleCount()));
      }

      function goTo(n) {
        idx = Math.max(0, Math.min(n, maxIdx()));
        track.style.transform = 'translateX(-' + (idx * cardWidth()) + 'px)';
      }

      panel._sbsGoTo      = goTo;
      panel._sbsGetIdx    = function () { return idx; };
      panel._sbsResetIdx  = function () { idx = 0; };

      // swipe
      var startX = 0;
      track.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      track.addEventListener('touchend',   function (e) {
        var d = startX - e.changedTouches[0].clientX;
        if (Math.abs(d) > 40) goTo(idx + (d > 0 ? 1 : -1));
      });

      window.addEventListener('resize', function () { goTo(idx); });
    }

    section.querySelectorAll('.sbs-panel').forEach(initCarousel);

    // ── Arrow visibility ────────────────────────────────────────────
    function activePanel() {
      return section.querySelector('.sbs-panel.active');
    }

    function updateArrowVisibility() {
      var p = activePanel();
      if (!p) return;
      var wrap  = p.querySelector('.sbs-carousel-wrap');
      var cards = p.querySelectorAll('.sbs-card').length;
      var vis   = wrap ? (wrap.offsetWidth < 600 ? 1 : wrap.offsetWidth < 992 ? 2 : 4) : 4;
      var arrowWrap = section.querySelector('.sbs-arrows');
      if (arrowWrap) arrowWrap.style.visibility = cards > vis ? 'visible' : 'hidden';
    }
    updateArrowVisibility();
    window.addEventListener('resize', updateArrowVisibility);

    // ── Arrow buttons ───────────────────────────────────────────────
    section.querySelectorAll('.sbs-arrow--prev').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var p = activePanel();
        if (!p) return;
        var track = p.querySelector('.sbs-track');
        var cw    = (function () { var c = track.querySelector('.sbs-card'); return c ? c.offsetWidth + 20 : 0; })();
        var cur   = Math.abs(parseInt((track.style.transform || '').replace('translateX(', '').replace('px)', '')) || 0);
        if (cw) track.style.transform = 'translateX(-' + Math.max(0, cur - cw) + 'px)';
      });
    });

    section.querySelectorAll('.sbs-arrow--next').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var p = activePanel();
        if (!p) return;
        var track = p.querySelector('.sbs-track');
        var wrap  = p.querySelector('.sbs-carousel-wrap');
        var cw    = (function () { var c = track.querySelector('.sbs-card'); return c ? c.offsetWidth + 20 : 0; })();
        var cards = track.querySelectorAll('.sbs-card').length;
        var vis   = wrap.offsetWidth < 600 ? 1 : wrap.offsetWidth < 992 ? 2 : 4;
        var maxPx = Math.max(0, (cards - vis)) * cw;
        var cur   = Math.abs(parseInt((track.style.transform || '').replace('translateX(', '').replace('px)', '')) || 0);
        track.style.transform = 'translateX(-' + Math.min(cur + cw, maxPx) + 'px)';
      });
    });

    // ── Tab pill switching ──────────────────────────────────────────
    section.querySelectorAll('.sbs-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        section.querySelectorAll('.sbs-pill').forEach(function (p) { p.classList.remove('active'); });
        this.classList.add('active');

        var targetId = this.getAttribute('data-panel');

        section.querySelectorAll('.sbs-panel').forEach(function (panel) {
          if (panel.id === targetId) {
            panel.classList.add('active');
            var track = panel.querySelector('.sbs-track');
            if (track) {
              track.style.transition = 'none';
              track.style.transform  = 'translateX(0)';
              requestAnimationFrame(function () {
                track.style.transition = 'transform 0.45s cubic-bezier(0.4,0,0.2,1)';
              });
            }
          } else {
            panel.classList.remove('active');
          }
        });
        updateArrowVisibility();
      });
    });
  }

  // ── Quick Add (global, safe to call if feature is enabled) ─────
  window.sbsQuickAdd = function (event, variantId) {
    event.preventDefault();
    event.stopPropagation();
    var btn = event.currentTarget;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      btn.textContent = '✓ Added!';
      setTimeout(function () { btn.textContent = 'Add To Cart'; }, 1800);
    })
    .catch(function () {
      btn.textContent = 'Add To Cart';
    });
  };

  // ── Auto-init all sbs-section elements on the page ─────────────
  function initAll() {
    document.querySelectorAll('.sbs-section[data-sbs-id]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme Editor support
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.sbs-section[data-sbs-id]');
    if (s) initSection(s);
  });

})();
